(function() {
    // 获取自定义参数 srmp
    var mulitParams = SR.util.urlParam('srmp');
    if (mulitParams) {
        SR.data.mulitParams = mulitParams;
        if (!SR.state.customMulitParams) {
            console.log('srmp params was found but customMulitParams switch was off');
        }
    }
})();